import { Component, OnInit, OnDestroy, Input, ViewChild, ViewChildren, QueryList } from '@angular/core';
import { NgForm } from '@angular/forms';

import { FesBaseComponent } from '../../../shared/components/fes-base.component';
import { AppState } from '../../../core';
import { ScoutTaskDoc } from '../../../core/schema/scout-task-schema';
import { ScoutTaskService } from '../../../core/services';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ConfirmModalComponent } from '../../../shared/components/confirm-modal/confirm-modal.component';
import { Azimuth, ScoutPath } from '../../../core/models';
import { AzimuthHelper } from '../../../core/azimuth-helper';
import { v4 as uuidv4 } from 'uuid'


@Component({
  selector: '[app-addl-azimuth]',
  templateUrl: './scout-path-addl-azimuth.component.html',
  styleUrls: ['./scout-path-azimuth.component.scss']
})
export class ScoutPathAddlAzimuthComponent implements OnInit {


  @Input() isEditing = false

  @Input() azimuth : Azimuth

  @Input() azimuths : Azimuth[] = []

  ngOnInit() : void {
  }

  oppositeAngle( angle: number ) {
    return AzimuthHelper.getOppositeAngle(angle)
  }

  onDelete() {
    const index = this.azimuths.findIndex(a=> a.id==this.azimuth.id)
    if ( index != -1 ) {
      this.azimuths.splice(index,1)
    }
  }
}


@Component({
  selector: 'app-scout-path-azimuth',
  templateUrl: './scout-path-azimuth.component.html',
  styleUrls: ['./scout-path-azimuth.component.scss']
})
export class ScoutPathAzimuthComponent  extends FesBaseComponent implements OnInit, OnDestroy {

  @Input() scoutTaskDoc : ScoutTaskDoc
  @Input() set scoutPath (sp : ScoutPath ){
    this._scoutPath = sp
    this.initFormValues()
  }
  get scoutPath() { return this._scoutPath }
  _scoutPath : ScoutPath
  
  @ViewChild('azimuthForm') azimuthForm: NgForm;
  @ViewChildren(ScoutPathAddlAzimuthComponent) addlAzimuthComponents!: QueryList<ScoutPathAddlAzimuthComponent>;

  //comment = new FormControl('');

  isEditing = false
  isSaving = false
  
  azimuthCorner : string
  azimuth1Angle : number
  azimuth2Angle : number
  addlAzimuths: Azimuth[] = []
  azimuth1Directions : string[] = []
  azimuth2Directions : string[] = []
  directions = AzimuthHelper.directions
  

  constructor( appState: AppState, protected scoutTaskService : ScoutTaskService, protected modalService : BsModalService ) { 
    super(appState)
  //  this.comment.setValidators( Validators.required )
  }
  

  ngOnInit() : void {
    this.subscribe( this.scoutTaskDoc.$, doc => {
      this.initFormValues()
    })
  }


  ngOnDestroy(): void {
    this.destroy()
  }


  async askDiscardEdits(acceptDiscardFn: () => void) {
    let initialState = {
      onYes: acceptDiscardFn,
      question: 'Discard unsaved scout path azimuth data?',
      focusOnNo: true,
      yesStyle: 'btn btn-danger'
    }
    this.modalService.config.animated = false    
    this.modalService.show(ConfirmModalComponent, { initialState });
  }


  initFormValues(bForceResetForm=false) {
    if ( this.scoutPath ) {
      if ( !this.scoutPath.azimuthCorner ) {
        this.scoutPath.azimuthCorner = ''
      }
      if ( !this.scoutPath.azimuth1Angle ) {
      this.scoutPath.azimuth1Angle = 0
      }
      if ( !this.scoutPath.azimuth2Angle ) {
        this.scoutPath.azimuth2Angle = 0
      }
      if ( bForceResetForm || !this.isEditing ) {
        this.azimuthCorner = this.scoutPath.azimuthCorner
        this.azimuth1Angle = this.scoutPath.azimuth1Angle
        this.azimuth2Angle = this.scoutPath.azimuth2Angle
        this.addlAzimuths = this.copyAddlAzimuths(this.scoutPath.addlAzimuths)
      } else {
        console.log('Azimuths being edited so keeping values')
      }
    } else {

    }
    this.updateAzimuths()
  }

  copyAddlAzimuths(src:Azimuth[]) : Azimuth[] {
    return src ? src.map( a => {return { id: a.id, title: a.title, angle: a.angle }}) : []
  }

  
  isModified = () => {
    return this.isEditing && 
    ( this.azimuth1Angle != this.scoutPath?.azimuth1Angle 
      ||this.azimuth2Angle != this.scoutPath?.azimuth2Angle
      ||this.azimuthCorner != this.scoutPath?.azimuthCorner || this.addlAzimuthModified() )
  }


  addlAzimuthModified = () => {
    const pristineAzimuths = this.scoutPath?.addlAzimuths || []
    if ( this.addlAzimuths.length != pristineAzimuths.length ) {
      return true
    }
    for ( var i = 0; i < this.addlAzimuths.length; i++ ) {
      const lhs = this.addlAzimuths[i]
      const rhs = pristineAzimuths[i]
      if ( lhs.id != rhs.id || lhs.angle != rhs.angle || lhs.title != rhs.title ) {
        return true
      }
    }
    return false
  }


  onAzimuthCornerChanged(evt:any){
    console.log('onAzimuthCornerChanged('+evt+')')
    console.log('corner ' + this.scoutPath.azimuthCorner)    
    const cornerDirections = AzimuthHelper.getCornerDirections(this.azimuthCorner)
    this.azimuth1Angle = AzimuthHelper.directionAngles[cornerDirections[0]]
    this.azimuth2Angle = AzimuthHelper.directionAngles[cornerDirections[1]]
    this.updateAzimuths()
  }  


  onAdd() {
    let newAzimuth = new Azimuth()
    newAzimuth.id = uuidv4()
    newAzimuth.title = 'Azimuth ' + ( 2 + this.addlAzimuths.length + 1 )
    this.addlAzimuths.push( newAzimuth )
  }


  onCancel() : void {
    this.isEditing = false
    this.initFormValues()
  }


  onEdit() {
    this.isEditing=true
    this.azimuthCorner = this.scoutPath.azimuthCorner  
    this.azimuth1Angle = this.scoutPath.azimuth1Angle  
    this.azimuth2Angle = this.scoutPath.azimuth2Angle  
  }


  async onSave() {
    this.isSaving = true
    try {
        await this.scoutTaskDoc.atomicUpdate( (taskDoc) => {
          let scoutPath = taskDoc.scoutPaths?.find(sp=>sp.id==this.scoutPath.id)
          this.scoutTaskService.assignWhoAndWhenForPath(scoutPath)
          scoutPath.azimuthCorner = this.azimuthCorner
          scoutPath.azimuth1Angle = Number(this.azimuth1Angle)
          scoutPath.azimuth2Angle = Number(this.azimuth2Angle)
          scoutPath.addlAzimuths = this.addlAzimuths
          return taskDoc
        })
        this.isEditing = false
        this.scoutPath = this.scoutTaskDoc?.scoutPaths.find(sp=>sp.id==this.scoutPath.id)
        this.initFormValues()
    } catch ( error ) {
      this.scoutTaskService.publishError(error,this)
      return false
    } finally {
      this.isSaving = false;
    }
  }

  
  toNumber(x:any) {
    return Number(x)
  }

  getOppositeDirection = (angle:number) => (angle+180)%360

  updateAzimuths() {
    try{
      const cornerDirections = AzimuthHelper.getCornerDirections(this.azimuthCorner)
      this.azimuth1Directions = []
      this.azimuth1Directions.push(AzimuthHelper.getOppositeDirection(cornerDirections[0]))
      this.azimuth1Directions.push(cornerDirections[0])
      this.azimuth2Directions = []
      this.azimuth2Directions.push(AzimuthHelper.getOppositeDirection(cornerDirections[1]))
      this.azimuth2Directions.push(cornerDirections[1])
    } catch ( error ) {
      console.error(error)
    }
  }


}



